import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Company, Project } from 'api/models';
import { NavParams, ModalController } from 'ionic-angular';
import { MeteorObservable, ObservableCursor } from 'meteor-rxjs';
import { EditCompanyInfoComponent } from '../edit-company-info/edit-company-info';
import { conformToMask } from 'angular2-text-mask';
import { HttpService } from '../../services/httpService';
// import { subscribeActiveCompany, subscribeActiveCompanyAdmins, getCompany, getCompanyAdmins } from '../../services/companyData';
import { CompanyService } from '../../services/companyData';
import { SharedService } from '../../services/sharedService';

@Component({
  selector: 'company-info-tab',
  templateUrl: 'company-info-tab.html'
})
export class CompanyInfoTab implements OnInit {
  company?: Company | void;
  companyProjects?: ObservableCursor<Project>;
  companyMembers?: Array<Meteor.User>;
  adminUsers?: Array<Meteor.User>;
  zipMask: Array<string|RegExp>;
  phoneMask: Array<string|RegExp>;

  constructor(
    public navParams: NavParams,
    private modalCtrl: ModalController,
    public httpService: HttpService,
    public companyService: CompanyService,
    private router: Router,
    private sharedService: SharedService,
  ) {
    this.zipMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
    this.phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  }

  ngOnInit(): void {
    const companyId = this.navParams.get('companyId');
    MeteorObservable.autorun().subscribe(() => {
      if (companyId) {
        this.company = this.companyService.getCompany(companyId);
        this.adminUsers = this.companyService.getCompanyAdmins(this.company);
      } else {
        this.company = this.companyService.subscribeActiveCompany();
        this.adminUsers = this.companyService.subscribeActiveCompanyAdmins();
      }
      // TODO - if we want to ditch the projectIds and memberIds array to check the length,
      // then we would do something like the below, and check the cursor length.
      // this.companyProjects = subscribeActiveCompanyProjects();
      // this.companyMembers = subscribeActiveCompanyMembers();
    });
  }

  goToEditCompanyInfo(): void {
    if (!this.company) {
      return;
    }
    const modal = this.modalCtrl.create(EditCompanyInfoComponent, {companyId: this.company._id}, {enableBackdropDismiss: false});
    modal.present();
    this.router.navigate([this.company.name, 'editDetails']);

    modal.onDidDismiss(() => {    
      if (this.company) {    
        this.router.navigate([this.company.name, 'details']);
      }
    });

  }

  // TODO - this will move to a separate page like "edit company"
  // leaving this here so it operates the same for now
  save(): void {
    if (!this.company) {
      return;
    }
    /*
    MeteorObservable.call('updateCompany', this.company._id, {
      name: this.company.name,
      code: this.company.code,
      town: this.company.town,
      state: this.company.state,
      zipCode: (this.company.zipCode || '').replace(/[^\d]/g, ''),
      phoneNumber: (this.company.phoneNumber || '').replace(/[^\d]/g, ''),
      address: this.company.address,
      country: this.company.country
    })
    .subscribe({
      next: () => {
        // this.navCtrl.push(CompanyPage);
      },
      error: (e: Error) => {
        // this.handleError(e);
      }
    });
    */

    this.httpService.MeteorCall('updateCompany', this.company._id, {
      name: this.company.name,
      code: this.company.code,
      town: this.company.town,
      state: this.company.state,
      zipCode: (this.company.zipCode || '').replace(/[^\d]/g, ''),
      phoneNumber: (this.company.phoneNumber || '').replace(/[^\d]/g, ''),
      address: this.company.address,
      country: this.company.country
    }).then(() => {
      // this.navCtrl.push(CompanyPage);
    })
    .catch((e: Error) => {
      // this.handleError(e);
    });
  }

  formatPhoneNumber(phoneNumberStr: void|string): string {
    const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    return conformToMask(phoneNumberStr || '', phoneMask, {guide:false}).conformedValue;
  }
}



// WEBPACK FOOTER //
// ./src/pages/company-info-tab/company-info-tab.ts